import { useEffect, useRef } from 'react';

import { type SegmentEventData, useAnalyticsContext } from '@/providers/AnalyticsProvider';

interface PageViewedEvent {
  data: SegmentEventData;
  eventName: string;
}

/** Tracks a page event once for each mounted page visit. */
export const usePageViewed = ({ data, eventName }: PageViewedEvent) => {
  const { trackSegmentEvent } = useAnalyticsContext();
  const hasViewed = useRef(false);

  useEffect(() => {
    if (hasViewed.current) return;

    hasViewed.current = true;
    trackSegmentEvent(eventName, data);
  }, [data, eventName, trackSegmentEvent]);
};
